export default __webpack_public_path__ + "static/media/DefaultUserAvt.8973ad91.png";